<template>
  <common-panel :panel-data="panelData"></common-panel>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel"
export default {
  name: "EnergyQualityReport",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        hasTree: true,
        treeProps: {
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.systemManage.getSiteTree,
        // queryMethod: this.$api.energyReport.getAnalyzeReport,
        filterForm: [
          {
            label: '时间：', prop: 'dataDate', type: 'year', value: new Date().Format('yyyy'), style: 'width: 160px;'
          }
        ],
        buttons: [
          {label: '预览', icon: 'zy-icon-password-show', type: 'toPdf', handleIndex: -3, text: true},
          {label: '下载', icon: 'zy-icon-download', type: 'downloadFile', handleIndex: -2, text: true}
        ],
        methods: {
          query_prop: 'id',
          query_id: 'id',
          excelAPI: '/energyReport/getReportFileById'
        },
        tableCheck: true,
        tableTitle: '分析报告列表',
        tableProps: [
          {prop: "fileName", label: "文件名称"},
          {prop: "dataDate", label: "报告月份", width: '240px'}
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/ReportManage/EnergyQualityReport.vue